import { TableCell, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ArrowDown2, ArrowUp2 } from "iconsax-react";
import { memo, useCallback } from "react";

import type { SortableColumnHeaderProps, SortDirection } from "./SortableColumnHeader.types";
import * as styles from "./SortableColumnHeader.styles";

export type { SortableColumnHeaderProps, SortDirection } from "./SortableColumnHeader.types";

function nextDirection(current: SortDirection): SortDirection {
  if (current === "none") return "asc";
  if (current === "asc") return "desc";
  return "none";
}

export const SortableColumnHeader = memo(function SortableColumnHeader({
  label,
  direction = "none",
  onSort,
}: SortableColumnHeaderProps) {
  const theme = useTheme();

  const handleClick = useCallback(() => {
    onSort?.(nextDirection(direction));
  }, [direction, onSort]);

  return (
    <TableCell sx={styles.root} onClick={handleClick}>
      <Typography component="span" sx={styles.content}>
        {label}
        <Typography component="span" sx={styles.arrows}>
          <ArrowUp2
            size={12}
            variant="Bold"
            color={direction === "asc" ? theme.palette.primary.main : theme.palette.text.disabled}
          />
          <ArrowDown2
            size={12}
            variant="Bold"
            color={direction === "desc" ? theme.palette.primary.main : theme.palette.text.disabled}
          />
        </Typography>
      </Typography>
    </TableCell>
  );
});
